import { apiFetch } from "@/shared/api/http";

export interface CompetitionPhoto { momentoId:string;midiaId:string;url:string; }
export interface CompetitionHistoryItem {
  campeonatoId:string;inscricaoId:string;campeonato:string;data:string;local:string|null;
  modalidadeId:string;modalidade:string|null;categoria:string;faixa:string|null;
  categoriaPeso:string|null;pesoKg:number;status:string;inscricaoExternaConfirmada:boolean;
  inscricaoExternaConfirmadaEmUtc:string|null;participacaoConfirmada:boolean;
  participacaoConfirmadaEmUtc:string|null;lutasRealizadas:number;vitorias:number;resultado:string|null;
  colocacao:number|null;certificadoUrl:string|null;linkOficial:string|null;linkMidia:string|null;
  fotos:CompetitionPhoto[];
}
export interface CompetitionDependent { alunoId:string;nome:string;competicoes:CompetitionHistoryItem[]; }
export const fetchMyCompetitions = () => apiFetch<CompetitionDependent[]>("/api/app/competicoes");

export const confirmExternalCompetitionRegistration = (inscricaoId:string, confirmada:boolean) => apiFetch<void>(`/api/app/competicoes/${encodeURIComponent(inscricaoId)}/inscricao-externa`, {method:"POST",body:JSON.stringify({confirmada})});
